import { useCallback } from 'react';
import { SkillsReportEvents, useSkillsReportAnalytics, } from '../../../hooks/useSkillsReportAnalytics';
import { useAppGoogleAnalytics } from '../../../../../../shared_app/hooks/useAppGoogleAnalytics';
var useStudentsSkillsTableAnalytics = function () {
    var ga4 = useAppGoogleAnalytics();
    var sendGaEvent = useSkillsReportAnalytics();
    var handleStudentNameClick = useCallback(function () {
        sendGaEvent(SkillsReportEvents.studentNameClick);
    }, [sendGaEvent]);
    var handleStudentSkillCellClick = useCallback(function () {
        sendGaEvent(SkillsReportEvents.studentSkillCellClick);
        ga4 === null || ga4 === void 0 ? void 0 : ga4.sendEventAsSupervizor({
            action: 'click_students_skill_supervizor',
            category: 'Skills Report',
        });
    }, [sendGaEvent]);
    var handleStudentRowClick = useCallback(function () {
        sendGaEvent(SkillsReportEvents.studentRowClick);
    }, [sendGaEvent]);
    var handleStudentReportLinkClick = useCallback(function () {
        sendGaEvent(SkillsReportEvents.studentReportLinkClick);
        ga4 === null || ga4 === void 0 ? void 0 : ga4.sendEventAsSupervizor({
            action: 'go_to_student_page_supervizor',
            category: 'Skills Report',
        });
    }, [sendGaEvent]);
    var handleExpandRowButtonClick = useCallback(function (isStruggle) {
        sendGaEvent(isStruggle
            ? SkillsReportEvents.struggleStudentRowExpand
            : SkillsReportEvents.studentRowExpand);
        ga4 === null || ga4 === void 0 ? void 0 : ga4.sendEventAsSupervizor({
            action: 'click_more_information_about_student_supervizor',
            category: 'Skills Report',
        });
    }, [sendGaEvent]);
    var handleChangePageClick = useCallback(function () {
        sendGaEvent(SkillsReportEvents.tableArrowClick);
        ga4 === null || ga4 === void 0 ? void 0 : ga4.sendEventAsSupervizor({
            action: 'click_next_skill_page_supervizor',
            category: 'Skills Report',
        });
    }, [sendGaEvent]);
    return {
        handleStudentNameClick: handleStudentNameClick,
        handleStudentSkillCellClick: handleStudentSkillCellClick,
        handleStudentRowClick: handleStudentRowClick,
        handleStudentReportLinkClick: handleStudentReportLinkClick,
        handleExpandRowButtonClick: handleExpandRowButtonClick,
        handleChangePageClick: handleChangePageClick,
    };
};
export { useStudentsSkillsTableAnalytics };
